export const COMMISSION_IMPORT_STATUS = {
  ACCEPTED: 'ACCEPTED',
  CANCELED: 'CANCELED',
  NEW: 'NEW',
  IMPORTED: 'IMPORTED',
};
